import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CardWrapper from "../CardWrapper";
import Card from "../Card";
import { getCnvTotalTranscripts } from "../../../state/selectors/CardsUI.selectors";

const TranscriptsCard = ({ card, totalTranscripts }) => {
  const isDisabled = !totalTranscripts;
  return (
    <CardWrapper {...card} isDisabled={isDisabled}>
      <div>
        <span className="tw-pr-1 tw-font-normal">Total transcripts: </span>
        {totalTranscripts}
      </div>
    </CardWrapper>
  );
};

TranscriptsCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  totalTranscripts: PropTypes.number,
};

TranscriptsCard.defaultProps = {
  totalTranscripts: 0,
};

const mapStateToProps = (state) => ({
  totalTranscripts: getCnvTotalTranscripts(state),
});

export default connect(mapStateToProps)(TranscriptsCard);
